(function AgentAttachmentUploadedAttachmentCategoryFilterForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentAttachmentUploadedAttachmentCategoryFilter',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$form.find("select").on('change', function viewCategory() {
			window.location = Adzuki.base_uri+'/AgentAttachments/uploadedAttachments/'+$("option:selected", this).val();
		});
	};

}(jQuery, window.Adzuki || {}));
